import { makeStyles, Theme } from '@material-ui/core';
import { Type, paddingType } from './index';
import { TextColor } from '../../enums';
import { distances } from '../../styles';

const getFontSize = (padding: paddingType) => {
  const fontSize: any = {
    small: 12,
    xmedium: 16,
    large: 16
  };
  return fontSize[padding] || 14;
};

export const useTabStyles = makeStyles<
  Theme,
  { padding: paddingType; type: keyof typeof Type }
>(theme => ({
  tab: {
    borderRadius: ({ type }) => (type === Type.rounded ? 99 : 0),
    textTransform: 'none',
    color: TextColor.SlateGrey,
    fontWeight: 500,
    fontSize: ({ padding }) => getFontSize(padding),
    padding: ({ padding }) => `${distances.medium}px ${distances[padding]}px`,
    lineHeight: '20px',
    width: 'max-content',
    minWidth: 'max-content',
    '&:hover': {
      backgroundColor: '#EEF0F2'
    },
    '& .MuiTab-wrapper': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
      '& .MuiSvgIcon-root': {
        margin: 0
      },
      '& svg': {
        margin: '0 !important',
        '& path': {
          fill: TextColor.SlateGrey,
          transition: 'fill 0.3s'
        }
      }
    },
    '&.Mui-selected svg path': {
      fill: '#fff !important'
    },
    '&.MuiTab-labelIcon': {
      minHeight: 'fit-content !important',
      opacity: 1
    }
  },
  activeTab: {
    // Temporary fix for MUI styles issue not being properly applied in MUI v5 on digital showroom project
    // requires MUI update to V5 and style refactoring (removing makeStyles)
    color: ({ type }) =>
      type === Type.rounded
        ? theme.palette.common.white
        : theme.palette.primary.main,
    transition: 'color 0.3s',
    fontWeight: 700,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height: ({ type }) => (type === Type.rounded ? '100%' : 2),
    '& > span': {
      width: '100%',
      // Temporary fix for MUI styles issue not being properly applied in MUI v5 on digital showroom project
      // requires MUI update to V5 and style refactoring (removing makeStyles)
      backgroundColor: theme.palette.primary.main,
      borderRadius: ({ type }) => (type === Type.rounded ? 99 : 0)
    }
  },
  root: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    borderRight: `1px solid ${theme.palette.divider}`,
    boxShadow: '0 0 20px rgba(0, 0, 0, 0.2)'
  }
}));
